import React, { Suspense, useEffect, useState } from 'react';

export default function SuspenseTracker({ fallback, onLoadStart, onLoadEnd, children }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    onLoadStart?.(); // Notify parent when loading starts
    return () => setLoaded(false);
  }, []);

  useEffect(() => {
    if (loaded) onLoadEnd?.();
  }, [loaded]);

  return (
    <Suspense fallback={fallback}>
      {React.cloneElement(children, { onLoadComplete: () => setLoaded(true) })}
    </Suspense>
  );
}
